var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c104_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6083 0.450931L25.3976 12.3782C25.3976 12.3782 26.8344 13.7956 25.2702 13.7956C23.7083 13.7956 19.9252 13.7956 19.9252 13.7956C19.9252 13.7956 19.9252 14.7504 19.9252 16.2169C19.9252 20.4176 19.9252 28.0484 19.9252 31.1545C19.9252 31.1545 20.1423 32 18.9072 32C17.6768 32 7.66291 32 6.78055 32C5.9029 32 5.92295 31.2931 5.92295 31.2931C5.92295 28.2705 5.92295 20.3759 5.92295 16.3212C5.92295 15.0081 5.92295 14.149 5.92295 14.149C5.92295 14.149 2.89129 14.149 0.987353 14.149C-0.91658 14.149 0.519037 12.6666 0.519037 12.6666C0.519037 12.6666 10.8892 1.52351 12.0111 0.355209C12.8285 -0.496474 13.6083 0.450931 13.6083 0.450931Z",
    fill: "url(#paint0_linear_56_666)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_666",
    x1: 13,
    y1: 0,
    x2: 13,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#149069"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowUp);
export default __webpack_public_path__ + "static/media/grow-up.cab0ad44933fa1b6513f245a99e90c97.svg";
export { ForwardRef as ReactComponent };